// extracted by mini-css-extract-plugin
export default {"result":"ResultWidget_result__wpzZR","company":"ResultWidget_company__lnOcF","name":"ResultWidget_name__jveBW"};